module.exports = __webpack_public_path__ + "static/media/6-4.03716355.mp3";